// This module exports various URL paths used in the application.
export const login = "organizations/";
export const organizationUrl = "organizations/";
export const organizationAdminUrl = "organizations/admin/";
export const acceptTermsAndConditionUrl = "organizations/accept-terms";
export const editSiteUrl = "/sites/";
export const pIEdit = "/principal-investigator/";
export const studyUrl = "/studies/";
export const commonUrl = "/common/";
